import { render, staticRenderFns } from "./UserPaymentNew.vue?vue&type=template&id=cf47dafe&scoped=true"
import script from "./UserPaymentNew.vue?vue&type=script&lang=js"
export * from "./UserPaymentNew.vue?vue&type=script&lang=js"
import style0 from "./UserPaymentNew.vue?vue&type=style&index=0&id=cf47dafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf47dafe",
  null
  
)

export default component.exports